import { render, staticRenderFns } from "./UserExchangeFormDialog.vue?vue&type=template&id=12b66810"
import script from "./UserExchangeFormDialog.vue?vue&type=script&lang=js"
export * from "./UserExchangeFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports